
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageCircle, Zap } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { messageDistributionService } from "@/services/messageDistributionService";

const MessageDistributionAdmin = () => {
  const [isDistributing, setIsDistributing] = useState(false);

  const handleDistributeQuotes = async () => {
    setIsDistributing(true);
    
    try {
      const result = await messageDistributionService.distributeHarryPotterQuotes();
      
      if (result.success) {
        toast({
          title: "Success!",
          description: result.message,
        });
      } else {
        toast({
          title: "Error",
          description: result.message,
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Error distributing quotes:', error);
      toast({
        title: "Error",
        description: "Failed to distribute Harry Potter quotes",
        variant: "destructive",
      });
    } finally {
      setIsDistributing(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Zap className="w-5 h-5 text-purple-500" />
          Harry Potter Quotes Distribution
        </CardTitle>
        <CardDescription>
          Send 5 Harry Potter quotes from every user to every other user
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="p-4 bg-purple-50 rounded-lg">
            <h4 className="font-medium text-purple-800 mb-2 flex items-center gap-2">
              <MessageCircle className="w-4 h-4" />
              What this does:
            </h4>
            <ul className="text-sm text-purple-700 space-y-1">
              <li>• Sends 5 random Harry Potter quotes from each user to all other users</li>
              <li>• Creates magical conversations across the platform</li>
              <li>• Uses famous quotes from the wizarding world</li>
              <li>• Each user receives quotes from every other user</li>
            </ul>
          </div>
          
          <Button
            onClick={handleDistributeQuotes}
            disabled={isDistributing}
            className="w-full"
            size="lg"
          >
            {isDistributing ? (
              <>
                <div className="animate-spin w-4 h-4 mr-2 border-2 border-white border-t-transparent rounded-full"></div>
                Distributing Harry Potter Quotes...
              </>
            ) : (
              <>
                <Zap className="w-4 h-4 mr-2" />
                Send Harry Potter Quotes to All Users
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default MessageDistributionAdmin;
